import pathWithRewrite from 'utils/pathWithRewrite';

const transformData = (data) => {
  const { teksti } = data;

  const pakalpojumi = {
    title: data.title,
    items: (data.pakalpojumi || []).filter(item => item && (item._id !== data._id) && item.title!=='').map(item => {
      const acf = JSON.parse(item.acf);
      return Object.assign({}, {
        title: item.title,
        description: acf && acf.apraksts,
      }, pathWithRewrite(item));
    }),
  };

  const hassRelatedSection = data.hasRelated && data.saistitiePakalpojumi &&
    data.saistitiePakalpojumi.length > 0;

  const composedData = {
    sections: {
      pakalpojumi,
    },
    teksti,
  };

  if (hassRelatedSection) {
    const saistitie_pakalpojumi = hassRelatedSection && {
      title: teksti.find(str => str._id === 'saistitie_pakalpojumi').text,
      items: (data.saistitiePakalpojumi || []).filter(item => item && (item._id !== data._id) && item.title!=='').map(item => {
        const acf = JSON.parse(item.acf);

        return Object.assign({}, {
          title: item.title,
          description: acf && acf.apraksts,
        }, pathWithRewrite(item));


      }),
    };

    composedData.sections.saistitie_pakalpojumi = saistitie_pakalpojumi;
  }

  return composedData;
};

export default transformData;



// WEBPACK FOOTER //
// ./src/pages/Apakskategorija/transformData.js